module.exports = __webpack_public_path__ + "static/img/6.32f6452.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/6.png
// module id = ib6I
// module chunks = 0